import {
  AdvancedMarker,
  InfoWindow,
  Pin,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps'
import { object } from 'prop-types'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'

const SterilizationCallMarker = ({ sterilizationCall }) => {
  const {
    position,
    companyName,
    sterilizationAddress,
    sterilizationZipCode,
    sterilizationDistrict,
    addressResponsibleFullName,
    addressResponsibleCellPhone,
    addressResponsibleEmail,
    callType,
    unitsNumber,
    scansData,
    isFirstScanned,
    isSecondScanned
  } = sterilizationCall
  const [t] = useTranslation('common')
  const [markerRef, marker] = useAdvancedMarkerRef()
  const [infoWindowShown, setInfoWindowShown] = useState(false)
  const handleMarkerClick = useCallback(
    () => setInfoWindowShown(isShown => !isShown),
    []
  )

  const handleClose = useCallback(() => setInfoWindowShown(false), [])

  const getPin = () => {
    const nonTreatedColors = { background: '#919090', borderColor: '#0a32c3', glyphColor: '#d6c11b' }
    const firstScannedColors = { background: '#6bc242', borderColor: '#0a32c3', glyphColor: '#d6c11b' }
    const secondScannedColors = { background: '#07adf5', borderColor: '#0a32c3', glyphColor: '#d6c11b' }

    let colors = nonTreatedColors
    const scannStatus = isFirstScanned ? 'first' : (isSecondScanned ? 'second' : 'pending')
    switch (scannStatus) {
      case 'first':
        colors = firstScannedColors
        break
      case 'second':
        colors = secondScannedColors
        break
    }

    return <Pin
      background={colors.background}
      borderColor={colors.borderColor}
      glyphColor={colors.glyphColor}
    />
  }

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={handleMarkerClick}
      >
        {getPin()}
      </AdvancedMarker>
      {infoWindowShown && (
        <InfoWindow anchor={marker} onClose={handleClose}>
          <h2>{addressResponsibleFullName}</h2>
          <p>
            {companyName ? `${companyName},` : ''}{`${sterilizationZipCode}, ${sterilizationAddress}, ${sterilizationDistrict ?? ''}`}<br />
            {`${addressResponsibleCellPhone}, ${addressResponsibleEmail ?? ''}`}<br />
            {`${t('table.CallerType')} : ${t(`table.${callType}`)}`}<br />
            {unitsNumber ? `${t('table.Units')}: ${unitsNumber}` : ''}
          </p>
          <Div cssClass='columns'>
            {scansData.isFirstScanned
              ? <Div cssClass='column'>
                <h4>{t('table.1st_scan')}</h4>
                <h5><span>{t('table.found_nests')}</span> :{scansData.firstScan.totalUnits}</h5>
                <h5><span>{t('table.empty_nests')}</span> :{scansData.firstScan.totalEmptyUnits}</h5>
                <h5><span>{t('table.nb_eggs')}</span> :{scansData.firstScan.totalEggs}</h5>
                <h5><span>{t('table.nb_non_treated_eggs')}</span> :{scansData.firstScan.totalNonTreatedEggs}</h5>
                <h5><span>{t('table.nb_birds')}</span> :{scansData.firstScan.totalBirds}</h5>
              </Div>
              : t('table.pending')
            }
            {scansData.isSecondScanned
              ? <Div cssClass='column'>
                <h4>{t('table.2nd_scan')}</h4>
                <h5><span>{t('table.found_nests')}</span> :{scansData.secondScan.totalUnits}</h5>
                <h5><span>{t('table.empty_nests')}</span> :{scansData.secondScan.totalEmptyUnits}</h5>
                <h5><span>{t('table.nb_eggs')}</span> :{scansData.secondScan.totalEggs}</h5>
                <h5><span>{t('table.nb_non_treated_eggs')}</span> :{scansData.secondScan.totalNonTreatedEggs}</h5>
                <h5><span>{t('table.nb_birds')}</span> :{scansData.secondScan.totalBirds}</h5>
              </Div>
              : t('table.pending')
            }
          </Div>
        </InfoWindow>
      )}
    </>
  )
}

SterilizationCallMarker.propTypes = {
  sterilizationCall: object
}

export default SterilizationCallMarker